(() => {
  if (window.hexibiiCreatorProductsReady) return;
  window.hexibiiCreatorProductsReady = true;
  const controllers = new WeakMap();
  const selections = new Map();
  const init = (scope = document) => {
    scope.querySelectorAll('[data-creator-products]').forEach(root => {
      if (controllers.has(root)) return;
      const choices = [...root.querySelectorAll('[data-guide-choice]')];
      const panels = [...root.querySelectorAll('[data-guide-panel]')];
      const select = root.querySelector('[data-guide-select]');
      const page = root.closest('.cro-creator-application');
      const selection = page.querySelector('[data-guide-selection]');
      const sectionKey = root.closest('[id^="shopify-section-"]')?.id || root.id;
      if (!panels.length || !select || !selection) return;
      let current = 0;
      const setChoice = index => {
        if (!panels[index]) index = 0;
        current = index;
        panels.forEach((panel, i) => { panel.hidden = i !== index; panel.open = i === index; });
        choices.forEach((choice, i) => { if (i === index) choice.setAttribute('aria-current', 'true'); else choice.removeAttribute('aria-current'); });
        select.value = String(index);
        selections.set(sectionKey, panels[index].dataset.guideBlock);
        selection.querySelector('[data-guide-selected-name]').textContent = panels[index].querySelector('h3').textContent;
        selection.querySelector('[data-guide-copy-status]').textContent = '';
      };
      controllers.set(root, {setChoice, panels});
      choices.forEach((choice, i) => choice.addEventListener('click', e => { e.preventDefault(); setChoice(i); }));
      select.addEventListener('change', () => setChoice(Number(select.value)));
      root.querySelectorAll('[data-guide-continue]').forEach(link => link.addEventListener('click', () => { setChoice(Number(link.dataset.guideContinue)); selection.hidden = false; }));
      selection.querySelector('[data-guide-copy]').addEventListener('click', async () => {
        const name = panels[current].querySelector('h3').textContent;
        const status = selection.querySelector('[data-guide-copy-status]');
        try { await navigator.clipboard.writeText(name); status.textContent = 'Copied'; }
        catch { status.textContent = 'Select and copy the product name above.'; }
      });
      const hash = location.hash.match(/^#creator-guide-(\d+)$/);
      const retained = panels.findIndex(panel => panel.dataset.guideBlock === selections.get(sectionKey));
      setChoice(retained >= 0 ? retained : hash ? Number(hash[1]) : 0);
      root.querySelector('.creator-products-mobile').hidden = false;
      root.classList.add('is-ready');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    document.querySelectorAll('[data-creator-products]').forEach(root => {
      const controller = controllers.get(root);
      if (!controller) return;
      const index = controller.panels.findIndex(panel => panel.dataset.guideBlock === e.detail?.blockId);
      if (index < 0) return;
      controller.setChoice(index);
      controller.panels[index].scrollIntoView({block: 'start', behavior: 'auto'});
    });
  });
})();
